import { CommandDispatcher } from "../../shared/domain/CommandDispatcher";
import { FileRepository } from "../../shared/domain/FileRepository";

export class UploadFileTransactions {
    constructor(
        private readonly dispatcher: CommandDispatcher,
        private readonly file_excel_repo: FileRepository,
        private readonly file_norma43_repo: FileRepository,
        private readonly frontend,
      ) {}

  async run(item:Object, file, type:string, listFilters, reconcile:boolean=false, excel_format=null): Promise<any> {
    let file_repo = undefined
    let command = ''
    let args = {}
    if (type == 'norma43') {
      file_repo = this.file_norma43_repo
      command = 'create.transactions.from.norma43'
    } else {
      file_repo = this.file_excel_repo
      command = 'create.transactions.from.excel'
      args['excel_format'] = excel_format
    }
    try {
      let file_path = await file_repo.uploadFile(file)
      args['file_path'] =  file_path
      args['bank_acc_id'] =  item['id']
      args['og_file_name'] =  file.name
      // let args = {
      //     file_path:file_path, 
      //     bank_acc_id:item['id'],
      //     og_file_name:file.name,
      // }
      let res =  await this.dispatcher.dispatch(command, args)

      this.frontend.uploadFileTransactionsJobState = 'running';
      this.frontend.uploadFileTransactionsJobId = res.job_id;
      this.frontend.dialog_upload_excel = false;
      this.frontend.changeLoadingUploadFileTransactions(false);
    }
    catch (error) {    
      console.error('Error upload transactions', error)
    }
    
    this.frontend.dialog_upload_excel = false;
    if (reconcile) {
      this.frontend.reconcile_with_excel = false;
    }
    this.frontend.changeLoadingUploadFileTransactions(false);
  }
}